module.exports = __webpack_public_path__ + "static/img/eyes_02.fa1ef58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c12/eyes_02.jpg
// module id = YAQx
// module chunks = 0